var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"flex1 text-center justify-center align-content-center",style:({ 'padding-top': _vm.paddingTop })},[_c('v-card-text',[_vm._v("Não existem dados a serem exibidos.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }